import DesignTool from "./designtool";
import Utils from "./utils";

class CircleItem {
  constructor(
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    angle,
    radius,
    hookPos
  ) {
    this.sizeID = sizeID;
    this.imageURL = imageDesign;
    this.size = size;
    this.productID = productID;
    this.productType = productType;
    this.angle = angle;
    this.hookPos = hookPos;
    this.circleRadius = radius;
    this.imageSize = imageSize > 0 ? imageSize : null;
    let sizes = this._calculateSizes(this.imageSize);
    this.scale = sizes.scale;
    // the angle of this item according to the radius
    this.a = sizes.displaySize / radius;
    this.c = (radius * this.a) ;
    this.x = 0;
    this.y = 0;
  }

  updateSizes(imageWidth, imageHeight) {
    this.imageSize = imageWidth;
    let sizes = this._calculateSizes(imageWidth, imageHeight);
    this.scale = sizes.scale;
    // the angle of this item according to the radius
    this.a =  sizes.displaySize / this.circleRadius ;// = Math.asin(sizes.displaySize / (2 * this.circleRadius)) * 2;  l=pi*R/apha ............
    let circuit = 2 * this.circleRadius * Math.PI;
    this.c = (circuit * this.a) / (2 * Math.PI);
  }

  updatePos(center) {
    this.angle = Utils.normalizeAngle(this.angle);
    let offSetX = this.hookPos
      ? this.imageSize / 2 - this.hookPos.hookX >= 2
        ? this.imageSize / 2 - this.hookPos.hookX - 2
        : this.imageSize / 2 - this.hookPos.hookX <= -2
        ? this.imageSize / 2 - this.hookPos.hookX + 2
        : this.imageSize / 2 - this.hookPos.hookX
      : 0;
    let offSetY = this.hookPos
      ? (108 / 2 - this.hookPos.hookY) * this.scale
      : 0;
    let x = (this.circleRadius + offSetY) * Math.cos(this.angle);
    let y = (this.circleRadius + offSetY) * Math.sin(this.angle);
    let rotation = (180 * this.angle) / Math.PI - 90;

    this.pos = { x: center.x + x, y: center.y + y, rotation: rotation };
    if (this.img) {
      this.img
        .set({
          left: this.pos.x,
          top: this.pos.y,
          angle: this.pos.rotation,
          transformMatrix: [1, 0, 0, 1, offSetX, 0]
        })
        .setCoords();
    }
  }

  getNumberPos(center) {
    let offSetX = this.hookPos
      ? this.imageSize / 2 - this.hookPos.hookX >= 2
        ? this.imageSize / 2 - this.hookPos.hookX - 2
        : this.imageSize / 2 - this.hookPos.hookX <= -2
        ? this.imageSize / 2 - this.hookPos.hookX + 2
        : this.imageSize / 2 - this.hookPos.hookX
      : 0;
    let offSetY = this.hookPos
      ? (108 / 2 - this.hookPos.hookY) * this.scale
      : 0;
    let sizes = this._calculateSizes(this.imageSize);
    let tmp = offSetY + sizes.displaySize;
    if (this.productType == 1) tmp *= 0.8;
    else if (this.productType == 5) tmp *= 1.5;
    else if (this.productType == 6) tmp *= 1.4;
    let x = (this.circleRadius + offSetY - tmp) * Math.cos(this.angle);
    let y = (this.circleRadius + offSetY - tmp) * Math.sin(this.angle);
    let rotation = (180 * this.angle) / Math.PI - 90;

    return { x: center.x + x, y: center.y + y, rotation: rotation };
  }

  updateRotation(center) {
    let rotation = (180 * this.angle) / Math.PI - 90;
    this.pos.rotation = rotation;
    if (this.img) {
      this.img
        .set({
          angle: this.pos.rotation
        })
        .setCoords();
    }
  }

  setPos(x, y) {
    if (this.img) {
      this.img
        .set({
          left: x,
          top: y
        })
        .setCoords();
    }
  }

  getLastAngle() {
    return Utils.normalizeAngle(this.angle + this.a / 2);
  }

  getFirstAngle() {
    return Utils.normalizeAngle(this.angle - this.a / 2);
  }

  _calculateSizes(_imageWidth, _imageHeight) {
    var imageSize = _imageWidth || 108;
    var imageHeight = _imageHeight || 108;
    var displaySize = 0;

    if (this.productType == 1) {
      displaySize =
        DesignTool.unitRatio * this.size * (imageSize / imageHeight);
    } else if (this.productType == 5) {
      imageSize = _imageWidth || 46;
      imageHeight = _imageHeight || 108;
      displaySize =
        DesignTool.unitRatio * this.size * (imageSize / imageHeight);
    } else if (this.productType == 6) {
      imageSize = _imageWidth || 120;
      displaySize =
        DesignTool.unitRatio * this.size * (imageSize / imageHeight);
    } else {
      imageSize = _imageWidth || 100;
      displaySize = DesignTool.unitRatio * this.size;
    }
    return {
      displaySize: this.hookPos
        ? (displaySize / imageSize) * this.hookPos.hookW
        : displaySize,
      imageSize: this.hookPos
        ? (displaySize / imageSize) * this.hookPos.hookW
        : imageSize,
      scale: displaySize / imageSize
    };
  }
}

export default CircleItem;
